<template>
    <div class="wrapFczs">
        <!--标题-->
        <div class="headerF">
            分类：
            <span
                :class="[{ chooseColor: isColor[index] }, headerSpanF]"
                v-for="(val, index) in arrOne"
                :key="index"
                @click="changeColor(index), changeData(val.id)"
                >{{ val.navigationName }}</span
            >
        </div>

        <!--内容-->
        <div class="contentF">
            <div
                class="boxF"
                v-for="(val, index) in arrTwo"
                :key="index"
                @click="goDetails(val.id)"
            >
                <div class="imgF scale-box">
                    <img :src="val.image" :alt="val.title" />
                </div>
                <div class="titleF">{{ val.title }}</div>
                <div class="timeF">
                    {{ val.creaTime && val.creaTime.time | dateFormat
                    }}<span class="viewF">浏览量:{{ val.popularity }}</span>
                </div>
            </div>
        </div>
        <pagebreak :totalPage="totalPage" @changePage="changePage"></pagebreak>
    </div>
</template>

<script>
export default {
    name: "fczs",
    data() {
        return {
            arrOne: [], //分类
            arrTwo: [],
            totalPage: 1,
            isColor: [],
            headerSpanF: "headerSpanF",
            classify: 9000
        };
    },
    methods: {
        //改变样式
        changeColor(index) {
            for (var i = 0; i < this.isColor.length; i++) {
                this.isColor[i] = 0;
            }
            this.isColor[index] = 1;
            this.$forceUpdate();
        },
        //改变分类
        changeData(x) {
            this.classify = x;
            this.getData(1);
        },
        //切换页码
        changePage(index) {
            this.getData(index);
        },
        //资讯详情
        goDetails(i) {
            this.$router.push({
                name: "fczsdetail",
                query: {
                    id: i,
                    t1: "风采展示"
                }
            });
        },
        getData(page) {
            this.$ajax({
                method: "post",
                url: "homePage/getInformation",
                data: {
                    current: page,
                    navigationId: this.classify
                },
                success: res => {
                    if (res.code == 200) {
                        this.totalPage = Math.ceil(
                            res.message.total / res.message.size
                        );
                        this.arrTwo = res.message.records;
                    }
                },
                error: res => {}
            });
        }
    },
    created() {
        this.getData(1);
        //获取导航栏
        this.$ajax({
            url: "homePage/myNavigation",
            method: "post",
            success: res => {
                if (res.code == 200) {
                    //获取风采展示分类列表
                    for (var i = 0; i < res.message.length; i++) {
                        if (res.message[i].id == 9000) {
                            this.arrOne = res.message[i].subList;
                            this.arrOne.unshift({
                                id: 9000,
                                navigationName: "全部"
                            });
                            for (var j = 0; j < this.arrOne.length; j++) {
                                this.isColor[j] = 0;
                            }
                            this.isColor[0] = 1;
                        }
                    }
                }
            },
            error: res => {}
        });
    }
};
</script>

<style scoped="scoped">
.wrapFczs {
    width: 1000px;
    overflow: hidden;
    margin: 30px auto;
    min-height: 500px;
}

.contentF {
    width: 1000px;
    min-height: 500px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    align-content: flex-start;
    cursor: default;
}

.headerSpanF {
    margin-right: 30px;
    cursor: pointer;
}

.boxF {
    width: 242px;
    display: inline-block;
    margin-top: 20px;
    margin-right: 10px;
    box-sizing: border-box;
}
.boxF:nth-child(4n) {
    margin-right: 0;
}

.imgF {
    width: 100%;
    height: 164.9px;
    border: 1px solid #ddd;
    box-sizing: border-box;
    overflow: hidden;
    cursor: pointer;
}
.imgF img {
    width: 100%;
    min-height: 100%;
    transition: all ease 0.2s;
}

.imgF:hover {
    border: 1px solid #999;
}

.titleF {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.timeF {
    color: gray;
    font-size: 14px;
    padding: 0 5px 0 0;
}

.viewF {
    float: right;
}

.chooseColor {
    color: #6ac0e8;
}
</style>



// WEBPACK FOOTER //
// src/components/gjtz/fczs.vue